import React, { Component } from 'react';
import { Card, Tabs } from 'antd';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import DateCondition from '@comm/search/DateSearch';
import util from '@util/index';
import { getPayableStatistics } from '@store/modules/incubator/payable_statis';
import { setBillTab } from '@store/modules/incubator/bill_tab';
import TablePending from './TablePending';
import TablePaid from './TablePaid';
import TableObsolete from './TableObsolete';
import TablePendingRefund from './TablePendingRefund';
import TableRefunded from './TableRefunded';

const { TabPane } = Tabs;
const type = ['押金', '工位收入', '地址收入'];
const payType = ['收入', '作废', '退回'];

class ComponentBill extends Component {
  constructor(props) {
    super(props);
    this.state = {
      condition: props.billTabStore.condition || {},
    };
  }

  componentWillMount() {
    this.pageDisplay = {};
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.dimenUuid).some(key => nextProps.dimenUuid[key] !== this.dimenUuid[key])
    ) {
      this.dimenUuid = nextProps.dimenUuid;
      this.getPayableStatistics();
    }
  }

  componentDidMount() {
    this.dimenUuid = this.props.dimenUuid;
    this.getPayableStatistics();
  }

  onPageChange = key => (currentType, page, pageSize) => {
    this.pageDisplay[`${key}Page`] = page;
    this.pageDisplay[`${key}Type`] = currentType;
    this.pageDisplay[`${key}PageSize`] = pageSize;
  };

  // 离开页面时，保存当前页面的状态
  componentWillUnmount() {
    this.props.dispatch(
      setBillTab({
        tab: this.key,
        ...this.dimenUuid,
        ...this.pageDisplay,
        condition: this.state.condition,
      }),
    );
  }

  getPayableStatistics = () => {
    this.props.dispatch(
      getPayableStatistics({
        ...this.dimenUuid,
        ...this.condition,
      }),
    );
  };

  callback = key => {
    this.key = key;
  };

  handleChange = params => {
    this.condition = params;
    this.getPayableStatistics();
    this.setState({
      condition: { ...params },
    });
  };

  render() {
    const {
      statisticsData: { pending, paid, obsolete, pendingRefund, refund, all },
      billTabStore,
      dimenUuid,
    } = this.props;

    const { incubatorUuid, customUuid } = dimenUuid; // 客户首页、合同首页参数不同
    const urlPrefix = `/incubator/one/${incubatorUuid}/`;

    // 非返回进入页面，初始化页面状态
    let billTab = {};
    if (billTabStore.incubatorUuid === incubatorUuid && customUuid === billTabStore.customUuid) {
      billTab = billTabStore;
    }

    const extra = (
      <div>
        <Link to={`${urlPrefix}refund`}>错款退还</Link>
        <Link to={`${urlPrefix}back`} style={{ paddingLeft: '8px' }}>
          退款
        </Link>
        <Link to={`${urlPrefix}income`} style={{ paddingLeft: '8px' }}>
          资金管理
        </Link>
        <Link style={{ paddingLeft: '8px' }} to={`${urlPrefix}invoice`}>
          开票管理
        </Link>
      </div>
    );

    const arr = [
      <div key={1}>
        <div>待收款</div>
        <p>{pending ? util.numberFormat(pending) : 0}</p>
      </div>,
      <div key={2}>
        <div>已收款</div>
        <p>{paid ? util.numberFormat(paid) : 0}</p>
      </div>,
      <div key={3}>
        <div>作废款</div>
        <p>{obsolete ? util.numberFormat(obsolete) : 0}</p>
      </div>,
      <div key={4}>
        <div>未退款</div>
        <p>{pendingRefund ? util.numberFormat(pendingRefund) : 0}</p>
      </div>,
      <div key={5}>
        <div>已退款</div>
        <p>{refund ? util.numberFormat(refund) : 0}</p>
      </div>,
    ];
    const parentProps = {
      billTab,
      type,
      payType,
      pageSize: this.props.pageSize || 10,
      condition: { ...this.state.condition, ...dimenUuid },
    };
    return (
      <Card title="账单管理" extra={!customUuid ? extra : null}>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ lineHeight: '32px', fontSize: '16px' }}>
              合同款总计：{all ? util.numberFormat(all) : 0}
            </div>
            <div>
              <DateCondition onChange={this.handleChange} defaultValue={this.state.condition} />
            </div>
          </div>
        </div>
        <Tabs defaultActiveKey={billTab.tab || '1'} onChange={this.callback}>
          <TabPane tab={arr[0]} key="1">
            <TablePending {...parentProps} onPageChange={this.onPageChange('pending')} />
          </TabPane>
          <TabPane tab={arr[1]} key="2">
            <TablePaid {...parentProps} onPageChange={this.onPageChange('paid')} />
          </TabPane>
          <TabPane tab={arr[2]} key="3">
            <TableObsolete {...parentProps} onPageChange={this.onPageChange('obsolete')} />
          </TabPane>
          <TabPane tab={arr[3]} key="4">
            <TablePendingRefund
              {...parentProps}
              onPageChange={this.onPageChange('pendingrefund')}
            />
          </TabPane>
          <TabPane tab={arr[4]} key="5">
            <TableRefunded {...parentProps} onPageChange={this.onPageChange('refuned')} />
          </TabPane>
        </Tabs>
      </Card>
    );
  }
}

export default connect(state => ({
  statisticsData: state.payable_statis,
  billTabStore: state.bill_tab,
}))(ComponentBill);



// WEBPACK FOOTER //
// ./src/components/incubator/bill/ComponentBill.js